import React from 'react';
import { Box, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { NotificationsOff } from '@mui/icons-material';

const ReminderBellStack = ({
  hasActiveReminder,
  onOpenReminder,
  onDismissReminder,
  isDismissing = false,
  dismissDisabled = false,
  placement = 'absolute',
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    if (hasActiveReminder) {
      onDismissReminder(event);
    } else {
      onOpenReminder(event);
    }
  };

  const containerSx =
    placement === 'absolute'
      ? {
          position: 'absolute',
          bottom: 2,
          right: 2,
        }
      : {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        };

  const tooltip = hasActiveReminder
    ? 'Wyłącz powiadomienie'
    : 'Otwórz klienta (przypomnienie w panelu)';

  return (
    <Box sx={containerSx} onClick={(event) => event.stopPropagation()}>
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            onClick={handleClick}
            disabled={isDismissing || (hasActiveReminder && dismissDisabled)}
            sx={{
              p: 0.75,
              color: hasActiveReminder ? 'error.main' : 'action.disabled',
              opacity: hasActiveReminder ? 1 : 0.5,
              bgcolor: hasActiveReminder ? 'error.50' : 'transparent',
              '&:hover': {
                bgcolor: hasActiveReminder ? 'error.100' : 'action.hover',
                color: hasActiveReminder ? 'error.dark' : 'action.active',
              },
            }}
          >
            {isDismissing ? (
              <CircularProgress size={18} />
            ) : (
              <NotificationsOff sx={{ fontSize: 20 }} />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ReminderBellStack;
